export const somenteDigitos = (valor?: string | null): string => (valor ?? '').replace(/\D/g, '');

const digitoVerificador = (digitos: string, pesoInicial: number): number => {
  const soma = digitos
    .split('')
    .reduce((total, digito, indice) => total + Number(digito) * (pesoInicial - indice), 0);

  const resto = (soma * 10) % 11;

  return resto === 10 || resto === 11 ? 0 : resto;
};

// A mascara do formulario aceita qualquer sequencia de 11 digitos, entao
// "111.111.111-11" passava. Sem os digitos verificadores, um CPF datilografado
// errado so seria descoberto na cobranca.
export const cpfValido = (valor?: string | null): boolean => {
  const digitos = somenteDigitos(valor);

  if (digitos.length !== 11) return false;
  // Todos os digitos iguais satisfazem a formula, mas nenhum e um CPF real.
  if (/^(\d)\1{10}$/.test(digitos)) return false;

  return (
    digitoVerificador(digitos.slice(0, 9), 10) === Number(digitos[9]) &&
    digitoVerificador(digitos.slice(0, 10), 11) === Number(digitos[10])
  );
};

export const formatarCpf = (valor?: string | null): string => {
  const digitos = somenteDigitos(valor).slice(0, 11);
  if (digitos.length !== 11) return digitos;

  return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6, 9)}-${digitos.slice(9)}`;
};
